import CustomError from './CustomError'

export default class InvalidPortalError extends CustomError {
  constructor(message: string) {
    super(message)
  }
}
